import { strip } from '@witmetrics/utils/strings';
import {
  buildUserOption,
  searchProjects as coreSearchProjects,
} from '@witmetrics/unison-core';
import type { FetchMatchingUnisonProjectsRequest } from '@witmetrics/api-client';
import { API } from '@/api';
import type { SearchableDropdownOption } from '@/components/inputs/SearchableDropdown';

export async function searchLeads(query: string) {
  const search = strip(query);
  let leadSuggestions: SearchableDropdownOption<number>[] = [];
  if (search.length > 0) {
    const leads = await API.Leads.fetchMatchingLeads({
      search,
      fields: ['firstname', 'lastname'],
      properties: [],
      filters: [],
      pagination: { page: 1, pageSize: 25 },
    });
    leadSuggestions = leads.results.map(buildUserOption);
  }
  return leadSuggestions;
}

export const searchProjects = (
  query: string,
  fields?: FetchMatchingUnisonProjectsRequest['fields']
) => coreSearchProjects(API, query, fields);
